import { Form } from 'react-bootstrap';
import { useState } from 'react';
import Swal from 'sweetalert2';

function DosageChangeComponent(props) {
  const { loading } = props;
  let insightAction = {
    medId: props.item.id,
    qty: props.item.settings.dosageQty,
    freq: props.item.settings.dosageFrequency,
    reason: '',
  };

  const actOptions = [
    {
      labelKey: '-Select-',
      value: '-Select-',
      isSelected: true,
      isDisabled: true,
    },
    {
      labelKey: 'per day',
      value: 'per day',
    },
    {
      labelKey: 'per week',
      value: 'per week',
    },
    {
      labelKey: 'per fortnight',
      value: 'per fortnight',
    },
    {
      labelKey: 'per month',
      value: 'per month',
    },
  ];

  const [freqState, setFreq] = useState(props.item.settings.dosageFrequency);
  const [setReason] = useState('');
  const [qtyState, setQty] = useState(props.item.settings.dosageQty);
  const [insightState, setInsightState] = useState(insightAction);

  function getActOptions() {
    return actOptions.map((option, index) => (
      <option key={`${option}-${index}`} value={option.labelKey}>
        {option.value}
      </option>
    ));
  }

  if (props.item) {
    const insightField = (field, selectedOptions) => {
      switch (field) {
        case 'freq':
          insightState.freq = selectedOptions.target.value;
          setFreq(selectedOptions.target.value);
          break;
        case 'qty':
          insightState.qty = Number.parseInt(selectedOptions.target.value);
          setQty(Number.parseInt(selectedOptions.target.value));
          break;
        case 'reason':
          insightState.reason = selectedOptions.target.value;
          setReason(selectedOptions.target.value);
          break;
        default:
          break;
      }
      setInsightState(insightState);
    };

    const onResetForm = (event) => {
      props.handleCancel(event);

      insightAction.freq = props.item.settings.dosageFrequency;
      setFreq(props.item.settings.dosageFrequency);

      insightAction.qty = Number.parseInt(props.item.settings.dosageQty);
      setQty(Number.parseInt(props.item.settings.dosageQty));

      insightAction.reason = '';
      setReason('');
    };
    return (
      <>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            if (
              insightState.qty &&
              insightState.freq &&
              insightState.freq !== '-Select-' &&
              insightState.qty > 0
            ) {
              props.handleSubmit(event, insightState);
            } else {
              Swal.fire({
                icon: 'warning',
                text: 'Please ensure all fields are filled out correctly',
                showConfirmButton: true,
              });
            }
          }}
        >
          <div id="txt3" className="flexVert divSelect">
            <div className="flexVertWrap mb-4">
              <label
                className="txtLeft txtDropdownLabel"
                style={{ whiteSpace: 'normal' }}
              >
                Dosage qty
              </label>
              <Form.Control
                type="number"
                rows={1}
                id="qtyTextbox"
                value={qtyState}
                onChange={(ev) => insightField('qty', ev)}
              />
            </div>

            <div className="flexVertWrap mb-4">
              <label
                className="txtLeft txtDropdownLabel"
                style={{ whiteSpace: 'normal' }}
              >
                Dosage frequency
              </label>
              <Form.Select
                className={'insightSelect'}
                id={'freq'}
                value={freqState}
                onChange={(ev) => insightField('freq', ev)}
              >
                {getActOptions()}
              </Form.Select>
            </div>
          </div>
          {props.popout && (
            <button
              disabled={loading}
              type="submit"
              className="btn btnPrimary btn-xs btn-long insight-popout-submit"
            >
              {loading ? 'Updating ...' : 'Update'}
            </button>
          )}
        </Form>
      </>
    );
  }
}

export { DosageChangeComponent };
